<template>
  <div>
    <EditPopup :data="data_popup" :show_dialog="popup" :close="close_method" />
    <v-dialog
      v-model="dialog"
      fullscreen
      scrollable
      :retain-focus="false"
      hide-overlay
    >
      <v-card class="wrapper">
        <div class="headbar">
          <div class="back" @click="close">
            <Icon name="left_blue" />
            <span>Назад</span>
          </div>
          {{ data.name }}
        </div>
        <div class="render_box">
          <div id="render" v-show="load"></div>
          <div class="load" v-show="!load">
            <v-progress-circular
              indeterminate
              color="#4B5EFF"
              size="40"
              width="4"
              class="mr-2"
            />
            Загрузка...
          </div>
          <div class="control" :class="{ open: control_open }">
            <div class="control_buttoms">
              <div
                class="item"
                @click="add_item(menu_item)"
                :class="menu_item.obj"
                v-for="(menu_item, index) in action_items"
                :key="index"
              >
                <div class="icon_wrapper">
                  <Icon :name="menu_item.icon" />
                </div>
                {{ menu_item.title }}
                <v-divider v-if="menu_item.obj == 'divider'"></v-divider>
              </div>
            </div>
            <div class="collapse" @click="control_open = !control_open">
              <Icon :name="[control_open ? 'left_arr' : 'right_arr']" />
            </div>
          </div>
          <div class="scenario-actions">
            <div class="btn_save" @click="save(true)">
              Сохранить и закрыть
            </div>
            <v-tooltip v-model="showSave" top color="success">
              <template v-slot:activator="{ attrs }">
                <div class="btn_save" @click="save()" v-bind="attrs">
                  Сохранить
                </div>
              </template>
              <span>Сохранено!</span>
            </v-tooltip>
            <div class="btn_test" @click="export_scenario()">
              Экспорт сценария
            </div>
            <div class="btn_test" @click="test_call()">
              Тестировать сценарий
            </div>
            <div class="import-file-container">
              <label for="fileInput" class="btn_test">Импортировать файл</label>
              <input
                id="fileInput"
                class="btn_test"
                type="file"
                ref="fileInput"
                @change="importFile"
                style="display: none"
              />
            </div>
          </div>
          <div class="scale_wrapper">
            <ScaleMy />
          </div>
        </div>
        <TestCall
          :show_dialog="testCall_popup"
          :data="call_data"
          :close="close_method"
        />
      </v-card>
      <v-snackbar v-model="invalidRobotSnack" :timeout="4000" top>
        <div class="snack-banner">
          <span
            >Невозможно сохранить Скрипт. Найдены пустые блоки «Реплика
            робота»</span
          >
          <div class="actions">
            <button class="link" @click="invalidRobotSnack = false">OK</button>
            <button class="link primary" @click="openRandomEmptyRobot()">
              Показать
            </button>
          </div>
        </div>
      </v-snackbar>
    </v-dialog>
  </div>
</template>

<script>
import EditPopup from './EditPopup.vue';
import TestCall from './TestCall.vue';
import Icon from '../../SetIcon.vue';
import ScaleMy from '../../ScaleMy.vue';

export default {
  components: {
    EditPopup,
    Icon,
    ScaleMy,
    TestCall,
  },
  props: ['show_dialog', 'close', 'lib', 'data', 'id', 'callback_refresh'],
  methods: {
    hasEmptyRobot(graph) {
      for (const node of Object.values(graph || {})) {
        if (!node || node.type !== 'robot') continue;

        const d = node.data || {};
        const t = Number(d.type ?? 0);

        if (t === 0 && !String(d.text || '').trim()) return true;

        if (t === 1 && !d.download) return true;

        if (t === 2 && !d.record) return true;
      }
      return false;
    },
    getEmptyRobotList(graph) {
      const res = [];

      for (const node of Object.values(graph || {})) {
        if (!node || node.type !== 'robot') continue;

        const d = node.data || {};
        const t = Number(d.type ?? 0);

        const empty =
          (t === 0 && !String(d.text || '').trim()) ||
          (t === 1 && !d.download) ||
          (t === 2 && !d.record);

        if (empty) res.push(d);
      }

      return res;
    },
    openRandomEmptyRobot() {
      let save = window.save_scenario({});
      if (typeof save === 'string') save = JSON.parse(save);

      const list = this.getEmptyRobotList(save);
      if (!list.length) return;

      const random = list[Math.floor(Math.random() * list.length)];

      this.robot_edit(random);
    },
    importFile(event) {
      this.importedFile = event.target.files[0];
      if (this.importedFile) {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          try {
            window.start_edit();
            const importedData = JSON.parse(e.target.result);
            const importedDataString =
              typeof importedData === 'string'
                ? importedData
                : JSON.stringify(importedData);

            this.$http.post(
              '/script/import',
              {
                id: this.id,
                data: {
                  data: importedDataString,
                },
              },
              (data) => {
                if (data) {
                  alert(
                    'Данные успешно импортированы, страница будет перезагружена!',
                  );
                  window.location.reload();
                } else {
                  alert('Вы выбрали неподходящий файл для импорта');
                }
              },
            );
          } catch (error) {
            console.error('Ошибка при чтении файла:', error);
            alert('Произошла ошибка при чтении файла');
          }
        };
        fileReader.onerror = () => {
          alert('Произошла ошибка при чтении файла');
        };
        fileReader.readAsText(this.importedFile);
      } else {
        console.error('Файл не выбран');
        alert('Файл не выбран');
      }
    },
    robot_edit(data) {
      window.start_edit();
      this.data_popup = data;
      let _this = this;
      setTimeout(function () {
        _this.popup = true;
      }, 50);
    },
    // 	importData() {
    // },
    export_scenario() {
      window.start_edit();
      this.call_data = window.save_scenario({});

      // save_scenario уже отдаёт JSON-строку — повторный stringify ломал импорт
      const content =
        typeof this.call_data === 'string'
          ? this.call_data
          : JSON.stringify(this.call_data);

      const safeName = String((this.data && this.data.name) || 'script')
        .replace(/[\\/:*?"<>|]/g, '_')
        .trim();

      const blob = new Blob([content], {
        type: 'application/json;charset=utf-8',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${safeName || 'script'}.json`;

      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      this.$http.post(
        '/script/export',
        {
          data: this.call_data,
        },
        (data) => {
          if (data && data.link) window.open(data.link, '_blank');
        },
      );
    },
    test_call() {
      window.start_edit();
      this.call_data = window.save_scenario({});
      this.testCall_popup = true;
    },
    close_method() {
      window.stop_edit();
      this.popup = false;
      this.testCall_popup = false;
      this.blacklist_popup = false;
    },
    cb_onload() {
      clearTimeout(this.initFallbackTimer);
      const elapsed = Date.now() - (this.reloadStartedAt || 0);
      const rest = Math.max(0, (this.minLoadMs || 0) - elapsed);
      setTimeout(() => {
        this.load = true;
      }, rest);
      // console.log('phaser onload')
    },
    add_item(item) {
      window.add_item(item.action, item);
    },
    save(close = false, reload = false) {
      let save = window.save_scenario({});
      if (typeof save === 'string') {
        try {
          save = JSON.parse(save);
        } catch (e) {
          console.log('save parse error', e);
        }
      }
      const user = this.$store.getters['user/getUserFields'];
      const isExceptionUser = user?.login === '79771012068';

      if (this.hasEmptyRobot(save) && !isExceptionUser) {
        this.invalidRobotSnack = true;
        return;
      }
      this.$http.post(
        '/script/save',
        {
          time: new Date().toLocaleString('en-US', { timeZoneName: 'short' }),
          id: this.id,
          save: {
            data: typeof save === 'string' ? save : JSON.stringify(save),
          },
        },
        (data) => {
          //this.callback_refresh()
          //this.close()
          //console.log(data) // auth_error
          this.reloadStartedAt = Date.now();
          this.load = false;
          this.skipReinitOnce = true;
          // eslint-disable-next-line vue/no-mutating-props
          this.data.data =
            typeof save === 'string' ? save : JSON.stringify(save);
          clearTimeout(this.initFallbackTimer);
          this.initFallbackTimer = setTimeout(() => {
            if (!this.load) this.load = true;
          }, 5000);
          if (data && data.error === 'syntese') {
            alert(
              'Скрипт сохранён, но озвучить реплики не удалось: сервис синтеза речи не ответил. Сохраните скрипт ещё раз через минуту, иначе звонки по нему не пройдут.',
            );
          }
          if (data === 'auth_error') {
            location.reload();
          } else {
            if (reload && data === true) {
              window.location.reload();
              return;
            }

            if (close) {
              this.callback_refresh();
              this.close();
              return data;
            } else {
              this.showSave = true;
              setTimeout(() => (this.showSave = false), 3000);
              return data;
            }
          }
        },
      );
    },
    saveInterval() {
      setTimeout(() => {
        if (this.dialog) {
          this.save(false, true);
        }
        this.saveInterval();
      }, 900000);
    },
  },
  watch: {
    'data.data'(val) {
      if (this.skipReinitOnce) {
        this.skipReinitOnce = false;
        return;
      }
      if (!val || !this.dialog) return;
      const cbs = { onload: this.cb_onload, robot_edit: this.robot_edit };
      window.clear_scenario();
      window.init_scenario(val, this.lib, cbs);
    },
    show_dialog: function (val) {
      this.dialog = val;
      if (val) {
        this.load = false;
        let cbs = {
          onload: this.cb_onload,
          robot_edit: this.robot_edit,
        };

        window.init_scenario(this.data.data, this.lib, cbs);
      } else {
        window.clear_scenario();
      }
    },
  },
  data() {
    return {
      invalidRobotSnack: false,
      skipReinitOnce: false,
      popup: false,
      minLoadMs: 300,
      reloadStartedAt: 0,
      initFallbackTimer: null,
      testCall_popup: false,
      control_open: true,
      data_popup: {},
      call_data: {},
      load: false,
      dialog2: false,
      action_items: [
        { title: 'Реплика робота', action: 'robot', icon: 'replic' },
        { title: 'Ответы клиента', action: 'answer', icon: 'answer' },
        { title: 'Перевести звонок', action: 'callcenter', icon: 'headphones' },
        { obj: 'divider' },
        { title: 'Отправить смс', action: 'send_sms', icon: 'sms' },
        {
          title: 'Отправить email',
          action: 'send_sms',
          icon: 'email',
          email: true,
        },
        {
          title: 'Email-уведомление',
          action: 'send_sms',
          icon: 'email',
          email_notification: true,
        },
        { title: 'Цель', action: 'target', icon: 'target' },
        {
          title: 'Переадресация на блок',
          action: 'forwarding',
          icon: 'forwarding',
        },
        {
          title: 'Отправить сообщение в телеграм',
          action: 'send_tg',
          icon: 'tg',
        },
        { title: 'Отправить http запрос', action: 'send_http', icon: 'code' },
        {
          title: 'Отправить в CRMCalls CC',
          action: 'send_crmcalls',
          icon: 'code',
        },
        { title: 'Интеграция amoCRM', action: 'amocrm', icon: 'integration' },
        { title: 'Интеграция Bitrix24', action: 'bitrix', icon: 'integration' },
        { title: 'Черный список', action: 'blacklist', icon: 'blacklist' },
      ],
      dialog: false,
      showSave: false,
      authErrorPopup: false,
    };
  },
  mounted() {
    this.saveInterval();
  },
};
</script>
<style>
.robot-snackbar .v-snack__wrapper {
  background: #111827 !important;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18) !important;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.robot-snackbar .v-snack__content {
  color: #fff !important;
  padding: 12px 16px !important;
}

.robot-snackbar .v-snack__wrapper::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #4b5eff;
}

.snack-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  font-weight: 500;
}

.snack-banner .actions {
  display: flex;
  gap: 10px;
}

.snack-banner .link {
  border: none;
  background: transparent;
  cursor: pointer;
  color: #fff;
  font-weight: 600;
  padding: 6px 8px;
  opacity: 0.8;
  transition: 0.15s;
}

.snack-banner .link:hover {
  opacity: 1;
  text-decoration: underline;
}

.snack-banner .link.primary {
  background: #4b5eff;
  color: #fff;
  border-radius: 8px;
  padding: 8px 12px;
  text-transform: none;
  font-size: 13px;
  letter-spacing: 0;
}
.add_modal {
  border: none;
  width: 100%;
  padding: 12px 20px 12px 22px;
  background: #4b5eff !important;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  justify-content: center;
  color: #eee;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-style: normal;
}
.popup_title {
  font-weight: 800;
  font-size: 24px;
  line-height: 130%;
  text-align: center;
  color: #2b2d33;
  margin: 16px 0 19px 0;
}
.divider .icon_wrapper {
  display: none;
}

.scenario-actions .btn_save,
.scenario-actions .btn_test {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex: 0 0 auto;
  width: auto;
  min-height: 50px;
  margin: 0;
  padding: 13px 24px;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 120%;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
}

.scenario-actions .btn_save {
  background: #4b5eff;
  color: #eee;
}

.scenario-actions .btn_test {
  color: #2b2d33;
  background: #ffffff;
}

.scale_wrapper {
  position: absolute;
  bottom: 30px;
  right: 30px;
}

.icon_wrapper {
  width: 28px;
  height: 28px;
  padding: 4px;
  background: #f8f8f8;
  border-radius: 4px;
  margin-right: 6px;
  margin-left: 12px;
}

.render_box {
  position: relative;
}

.load {
  width: 100%;
  height: calc(100vh - 48px);
  overflow: hidden;
  line-height: calc(100vh - 48px);
}

#render {
  width: 100%;
  height: calc(100vh - 48px);
  overflow: hidden;
}

.scenario-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  position: absolute;
  bottom: 16px;
  left: 20px;
  right: 170px;
}

.item {
  display: none;
}

.control.open .item {
  text-align: left;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 9px 12px;
  margin-top: 12px;
  margin-bottom: 12px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
  color: #2b2d33;
  padding-right: 40px;
}

.item:hover {
  background: #f8f8f8;
}

.divider {
  padding: 0;
}

.divider:hover {
  cursor: initial;
  background: #fff;
}

.control {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  padding: 4px 0;
  margin-top: 150px;
  background: #ffffff;
  border-radius: 6px 0 0 6px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 3px 8px rgba(0, 0, 0, 0.1);
}

.control.open {
  /*width: 250px;*/
  /*left: 15px;*/

  /*width: 250px;*/
  /*left: 15px;*/
  /*max-height: 65%;*/

  width: 250px;
  left: 15px;
  max-height: 60vh;
  height: available;
  height: -webkit-fill-available;
}

.control_buttoms {
  /*width: 250px;*/
  /*left: 15px;*/
  /*max-height: 65%;*/
  width: 100%;
  /*overflow-y: scroll;*/
  max-height: 100%;
  overflow-y: auto;
  position: absolute;
  top: 0;
  bottom: 0;
}

.collapse {
  position: absolute;
  right: -30px;
  /*right: 0px;*/
  width: 30px;
  top: 0;
  background: #fff;
  outline: 1px solid #e2e2e2;
  border-radius: 0 6px 6px 0;
  /*height: 100%;*/
  display: flex;
  align-items: center;
  justify-content: center;
  /*height: 590px;*/
  height: 60vh;
}

.headbar {
  text-align: center;
  height: 48px;
  padding-left: 20px;
  padding-right: 20px;
  font-weight: 700;
  font-size: 17px;
  line-height: 48px;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.06), 0px 1px 2px rgba(0, 0, 0, 0.1);
}

.headbar .back {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 12px;
  float: left;
  font-weight: 500;
  font-size: 15px;
  color: #4b5eff;
}

.headbar .back span {
  margin-left: 12px;
}

.scenario-actions .import-file-container {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}

@media (max-width: 600px) {
  .scenario-actions {
    right: 20px;
  }

  .scale_wrapper {
    top: 30px;
    left: 30px;
    bottom: initial;
    right: initial;
  }
}

@media (max-width: 450px) {
  .scenario-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .scenario-actions .btn_save,
  .scenario-actions .btn_test {
    width: 100%;
    white-space: normal;
  }
}
</style>
